export interface MaritalStatus {
  single: string;
  married: string;
  separated: string;
  divorced: string;
  widowed: string;
}
